module.exports = __webpack_public_path__ + "media/images/greg-1d02a09a.jpg";